<template>
  <div>
    <p>Loading...</p>
    {{ error }}
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      error: ''
    }
  },
  methods: {
    handleLoginEvent(data) {
      if (!data.error) {
        this.listClusters();
        this.$router.push(data.state.target || "/");
      }
    },
    ...mapActions(['listClusters'])
  },
  created() {
    this.$auth.handleAuthentication().then(() => {})
    .catch(err => { this.error = err.errorDescription });
  }
};
</script>
